<template>
  <path
    d="M22 12.0002C22 6.48024 17.52 2.00024 12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 16.8402 5.44 20.8702 10 21.8002V15.0002H8V12.0002H10V9.50024C10 7.57024 11.57 6.00024 13.5 6.00024H16V9.00024H14C13.45 9.00024 13 9.45024 13 10.0002V12.0002H16V15.0002H13V21.9502C18.05 21.4502 22 17.1902 22 12.0002Z"
  />
</template>
